import { Fragment } from "react"
import {
  CurrentMonth,
  MonthGrid,
  HeaderWrapper,
  MonthButton,
  MonthButtonText,
  NavigateButton,
  NavigationButtonWrapper,
} from "./styled"
import { Dayjs } from "dayjs"
import LeftIcon from "./Icons/LeftIcon"
import RightIcon from "./Icons/RightIcon"
import { isMonthUnder16YearOld } from "./birthdateValidators"
import { FlexBox } from "components/Common/FlexBox"

const MonthSelection = ({
  value,
  month,
  setMonth,
  onSelectMonth,
}: {
  value?: Dayjs
  month: Dayjs
  setMonth: (month: Dayjs) => void
  onSelectMonth: (month: Dayjs) => void
}) => {
  return (
    <Fragment>
      <HeaderWrapper>
        <CurrentMonth> {month.format("YYYY")}</CurrentMonth>

        <FlexBox $gap={8}>
          <NavigationButtonWrapper>
            <NavigateButton onClick={() => setMonth(month.subtract(1, "year"))}>
              <LeftIcon />
            </NavigateButton>
          </NavigationButtonWrapper>

          <NavigationButtonWrapper>
            <NavigateButton onClick={() => setMonth(month.add(1, "year"))}>
              <RightIcon />
            </NavigateButton>
          </NavigationButtonWrapper>
        </FlexBox>
      </HeaderWrapper>

      <MonthGrid>
        {Array.from({ length: 12 }, (_, i) => {
          const monthDate = month.month(i)

          const isDisabled = isMonthUnder16YearOld(monthDate.startOf("month"))
          const isSelected = !!value && value.isSame(monthDate, "month")

          return (
            <MonthButton
              key={i}
              onClick={() => {
                if (!isDisabled) {
                  onSelectMonth(monthDate)
                }
              }}
              $isDisabled={isDisabled}
            >
              <MonthButtonText
                $isSelected={isSelected}
                $isDisabled={isDisabled}
              >
                {monthDate.format("MMM")}
              </MonthButtonText>
            </MonthButton>
          )
        })}
      </MonthGrid>
    </Fragment>
  )
}

export default MonthSelection
